import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ParametrosQuaPss } from '../models/parametros-qua-pss';
import { ParametrosBancaPss } from '../models/parametros-banca-pss';
import { ParametrosConcurso } from '../models/parametros-concurso';
import { Inscricao } from '../models/inscricao-model';
import { saveAs } from 'file-saver';
import { filterBy, ResultGetPaged } from 'pmv-common';
import { InscricaoFilter } from '../models/inscricao-filter';
import { ItemEdital } from '../models/edital-item-model';
import { InscricaoDeficienteFilter } from '../models/inscricao-deficiente-filter';
import { InscricaoDeficiente } from '../models/inscricao-deficiente.model';
import { Periodo } from '../models/periodo.model';
import { ConvocacaoDeficienteEquipe } from '../models/convocacao-deficiente-equipe-model';
import { EditalArquivosInscricao } from '../models/editalArquivosInscricao';
import { PodeInscrever } from '../models/podeInscrever';

@Injectable()
export class InscricaoService {

  constructor(private httpClient: HttpClient) { }

  GetArquivosInscricaobyId(inscricao: Inscricao): Observable<EditalArquivosInscricao> {
    return this.httpClient.post<EditalArquivosInscricao>(`/Inscricao/GetArquivosInscricao/`, inscricao);
  }

  GetPontuacaoQualificacao(concurso: number, cdItemFormConc: number): Observable<ParametrosQuaPss> {
    return this.httpClient.get<ParametrosQuaPss>(`/Inscricao/GetPontuacaoQualificacao/${concurso}/${cdItemFormConc}`);
  }

  GetParametrosBanca(concurso: number): Observable<ParametrosBancaPss> {
    return this.httpClient.get<ParametrosBancaPss>(`/Inscricao/GetParametrosBanca/${concurso}`);
  }

  GetTempoExigencia(concurso: number, itemConc: number): Observable<ParametrosConcurso> {
    return this.httpClient.get<ParametrosConcurso>(`/Inscricao/GetTempoExigencia/${concurso}/${itemConc}`);
  }

  Create(inscricao: Inscricao): Observable<Inscricao> {
    return this.httpClient.post<Inscricao>(`Inscricao/PostInscricao/`, inscricao);
  }

  ExcluirEquipeDef(matricula: number, codEditalDef: number): Observable<void> {
    return this.httpClient.delete<void>(`/Inscricao/DeleteEquipeDef/${matricula}/${codEditalDef}`);
  }

  AdicionarEquipeDef(equipe: ConvocacaoDeficienteEquipe): Observable<void> {
    return this.httpClient.post<void>(`/Inscricao/PostEquipeDef/`, equipe);
  }

  GetIncricoes(page?: number, itemsPerPage?: number, filter?: InscricaoFilter): Observable<ResultGetPaged<Inscricao>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Inscricao>>('/Inscricao/GetIncricoes', filter);
  }

  GetIncricoesDeficiente(page?: number, itemsPerPage?: number, filter?: InscricaoDeficienteFilter): Observable<ResultGetPaged<InscricaoDeficiente>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<InscricaoDeficiente>>('/Inscricao/GetIncricoesDeficiente', filter);
  }

  GetProcessoClassificacaoDef(edital: number, ano: number): Observable<string> {
    return this.httpClient.get<string>(`/Inscricao/GetProcessoClassificacaoDef/${edital}/${ano}`);
  }

  GetInscricoesById(inscricao: Inscricao): Observable<Inscricao[]> {
    return this.httpClient.get<Inscricao[]>(`/Inscricao/GetIncricoesById/${inscricao.concurso}/${inscricao.nrInscricao}`);
  }

  ExcluirInscricao(inscricao: Inscricao): Observable<Inscricao[]> {
    return this.httpClient.get<Inscricao[]>(`/Inscricao/ExcluirInscricao/${inscricao.concurso}/${inscricao.nrInscricao}`);
  }

  GetCandidatoPodeInscrever(codPessoa: number, itemConcurso: number): Observable<PodeInscrever> {
    return this.httpClient.get<PodeInscrever>(`/Inscricao/GetValidarPedidoInscricao/${codPessoa}/${itemConcurso}`);
  }

  GetIncricoesCandidato(codPessoa: number, itemconc: number, cdhierarq: number): Observable<string> {
    return this.httpClient.get<string>(`/Inscricao/GetIncricoesCandidato/${codPessoa}/${itemconc}/${cdhierarq}`);
  }

  GetReservaIncricaoGeral(edital?: string, cargo?: string, ano?: string, cargaHoraria?: string): Observable<Number> {
    let url = `/Inscricao/GetReservaIncricaoGeral`;
    if (edital) {
      url += `?edital=${edital.replace('/', '|')}&cargo=${cargo.replace('/', '|')}&ano=${ano.replace('/', '|')}&cargaHoraria=${edital.replace('/', '|')}`;
    }
    return this.httpClient.get<Number>(url);
  }

  GetReservaIncricaoDef(edital?: string, cargo?: string, ano?: string, cargaHoraria?: string): Observable<Number> {
    let url = `/Inscricao/GetReservaIncricaoDef`;
    if (edital) {
      url += `?edital=${edital.replace('/', '|')}&cargo=${cargo.replace('/', '|')}&ano=${ano.replace('/', '|')}&cargaHoraria=${edital.replace('/', '|')}`;
    }
    return this.httpClient.get<Number>(url);
  }

  ClassificarCandidato(concurso: number): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Inscricao/PostClassificar/`, concurso);
  }


  GetNumeroConcurso(edital?: string, ano?: string): Observable<ItemEdital> {
    let url = `/Inscricao/GetNumeroConcurso`;
    if (edital) {
      url += `?edital=${edital.replace('/', '|')}&ano=${ano.replace('/', '|')}`;
    }
    return this.httpClient.get<ItemEdital>(url);
  }

  GerarRelatorioInscricao(inscricao: Inscricao) {
    this.httpClient.get(`Report/GetComprovanteInscricao/${inscricao.concurso}/${inscricao.nrInscricao}`,
      { responseType: 'blob' }
    ).subscribe(relatorio => {
      const dataAtual = new Date().toISOString();
      const nomeArquivo = `comprovante-inscricao-${dataAtual}.pdf`;
      saveAs(relatorio, nomeArquivo);
    }, error => {
      console.error(error);
      throw error;
    });
  }

  GerarRelatorioResultadoFinal(codConcurso: number) {
    this.httpClient.get(filterBy(codConcurso, `Report/GetRelatorioResultadoFinalPss/${codConcurso}`),
      { responseType: 'blob' }
    ).subscribe(relatorio => {
      const dataAtual = new Date().toISOString();
      const nomeArquivo = `resultado-final-${dataAtual}.pdf`;
      saveAs(relatorio, nomeArquivo);
    }, error => {
      console.error(error);
      throw error;
    });
  }

  getQuantDiasPeridos(listaExperienciaAuxiliar: Periodo[]): Observable<number> {
    return this.httpClient.post<number>(`/Inscricao/GetQuantDiasPeriodos`, listaExperienciaAuxiliar);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/inscricao.service.ts